// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-live-reservation-bpc[data-v-8c27d37e] {\n  width: 100%;\n  max-width: 750px;\n  margin: 0 auto;\n}\n.page-live-reservation-bpc img[data-v-8c27d37e] {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
